"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ixdIconsReact = require("@tencent/ixd-icons-react");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/** *
 * origin component
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var FlexCard = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props || {},
    icon = _a.icon,
    banner = _a.banner,
    sharp = _a.sharp,
    radius = _a.radius,
    configuration = _a.configuration,
    flexTitle = _a.flexTitle,
    themeBackGround = _a.themeBackGround,
    //  背景颜色主题
    description = _a.description,
    style = _a.style,
    className = _a.className,
    onClick = _a.onClick,
    restProps = __rest(_a, ["icon", "banner", "sharp", "radius", "configuration", "flexTitle", "themeBackGround", "description", "style", "className", "onClick"]);
  var compatibleArr = configuration.slice(0, 2) || [];
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'imcode-card_container'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'imcode-card_children'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'imcode-card_children__article'
  }, compatibleArr && compatibleArr.map(function (items, index) {
    var _a = items || {},
      imageSrc = _a.imageSrc,
      article = _a.article,
      title = _a.title,
      href = _a.href,
      supplement = _a.supplement,
      hrefText = _a.hrefText;
    var url = (0, _utils.fomateFileData)(imageSrc).url;
    return /*#__PURE__*/_react["default"].createElement("section", {
      key: index,
      className: (0, _classnames["default"])('imcode-card-list', {
        'imcode-card-list--status': supplement,
        'imcode-card-list--one': compatibleArr.length === 1
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'imcode-card-image'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: title
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('imcode-default-article', className),
      onClick: function onClick() {
        if (!href) return;
        window.location.href = href;
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('imcode-article-container', {})
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'imcode-article-top'
    }, title && (/*#__PURE__*/_react["default"].createElement("strong", {
      className: (0, _classnames["default"])('wordBreak lineBreak tci__text-head__head-3')
    }, title)), /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('imcode-div-content')
    }, article)), href && (/*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('imcode-show-more'),
      onClick: function onClick() {
        if (!href) return;
        window.location.href = href;
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, hrefText || 'Learn more'), /*#__PURE__*/_react["default"].createElement(_ixdIconsReact.RightIcon, {
      className: 'imcode-right-icon'
    }))))));
  }))));
});
FlexCard.displayName = 'SelfFlexCard';
var _default = exports["default"] = FlexCard;